module.exports = __webpack_public_path__ + "static/media/11-1.d8d9dffe.mp3";